export default __webpack_public_path__ + "static/media/books2-afterB-768w.3b02cadf.webp";